// material colors 800

const Logger = (message: string): void => {
  console.log(`%cFlomni%c : ${message}`, getStyles('#c62828'), '')
}

Logger.warn = (message: string): void => {
  console.log(`%cFlomni%c : ${message}`, getStyles('#f9a825'), '')
}

Logger.error = (message: string): void => {
  console.log(`%cFlomni%c : ${message}`, getStyles('red'), '')
}

const getStyles = (color: string): string => {
  return `background: ${color}; font-weight: 600; margin: 5px 0 5px 10px; padding: 2px 4px; border-radius: 4px`
}

export default Logger
